import React from 'react';
import PropTypes from 'prop-types';
import { Input, Icon } from 'semantic-ui-react';
import {
	getObjPropRecursively,
	pushToObjProp,
	removeFromObjProp,
	setObjProp
} from '../../utils';

class FileInputWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.onChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value != prevProps.value) {
      this.updateValue();
    }
  }

  componentDidMount() {
    this.updateValue();
  }

  updateValue = () => {
    this.setState({
      value: this.props.value
    });
  };

  /**
   * stores change in it's state and propagates change to parent
   * @param e
   */
  handleChange(e) {
    this.onChangeValue(e.currentTarget.files, false);
  }

  onChangeValue = (files, isRemoval = false, indexToRemove = null) => {
    const { values, name, fileDataProp } = this.props;
    if (files) {
      //file removal
      if (isRemoval) {
        let fileArray = getObjPropRecursively(values, name);
        //logical removal if already saved
        if (fileArray[indexToRemove].id) setObjProp(fileArray[indexToRemove], (fileDataProp ? `${fileDataProp}.deleted` : 'deleted'), true);
        //else actual removal
        else removeFromObjProp(values, name, indexToRemove);
        //file addition
      } else {
        for (let i = 0; i < files.length; i++) {
          let newFileName = files[i].name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9.()]/g, '_');
          let newFileData = {
            name: newFileName,
            format: files[i].type
          }; //format used for type validation
          let reader = new FileReader();
          reader.onload = readerEvt => {
            newFileData.fileBase64 = window.btoa(readerEvt.target.result);
            newFileData.file = files[i];
          };
          reader.readAsBinaryString(files[i]);
          pushToObjProp(values, name, !!fileDataProp ? {[fileDataProp]: newFileData}: newFileData);
        }
      }
      this.setState({ value: getObjPropRecursively(values, name) });
      this.props.setFieldValue(name, this.state.value);
      this.props.onChange(this.state.value);
    }
  };

  resetInput() {
    const valTmp = this.props.values;
    Object.keys(valTmp).forEach(entry => {
      delete valTmp[entry];
    });
    this.props.setValues(valTmp);
    this.setState({ value: '' });
  }

  /**
   * Get the file input area
   * @returns {*}
   */
  getFileInput = () => {
    const { name, disabled, displayInput, multiple, accept } = this.props;
    return (
      <>
        {!disabled && displayInput && (
          <div className="fileWrapperUploader">
            <label htmlFor={name}>
              <Icon link name="upload" size="large" />
            </label>
            <Input
              fluid
              id={name}
              name={name}
              type="file"
              multiple={multiple}
              accept={accept}
              onChange={this.onChange}
            />
          </div>
        )}
      </>
    );
  };

  errorMessageIcon = (
    <label className="error field">
      <Icon link name="exclamation triangle" size="small" />
    </label>
  );

  render() {
    const { fileViewerRender } = this.props;
    return (
      <>
        {this.getFileInput()}
        {fileViewerRender({
          ...this.props,
          value: this.state.value,
          valueLength: this.state.value?.length,
          onChangeValue: this.onChangeValue
        })}
      </>
    );
  }
}

FileInputWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  displayInput: PropTypes.bool.isRequired,
  fileViewerRender: PropTypes.func.isRequired
};

FileInputWrapper.defaultProps = {
  disabled: false,
  displayInput: true,
  onChange: () => {},
  multiple: false,
  accept: '',
	fileDataProp: '',
};

export default FileInputWrapper;
